module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__pagination-paginator"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('ul', [(_vm.prev) ? _c('li', {
    staticClass: "prev"
  }, [_c(_vm.prevDisabled ? "div" : "ext-link", {
    tag: "ext-link",
    staticClass: "link",
    attrs: {
      "size": "normal",
      "to": _vm.getLink(_vm.current - 1)
    }
  }, [_vm._t("prev", [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.prevText)
    }
  })])], 2)], 1) : _vm._e(), _vm._l((_vm.items), function(item) {
    return _c('li', {
      staticClass: "page"
    }, [_c(_vm.disabled(item.number) ? "div" : "ext-link", {
      tag: "ext-link",
      staticClass: "link",
      attrs: {
        "size": "normal",
        "to": item.to
      }
    }, [_vm._v(_vm._s(item.text))])], 1)
  }), (_vm.next) ? _c('li', {
    staticClass: "next"
  }, [_c(_vm.nextDisabled ? "div" : "ext-link", {
    tag: "ext-link",
    staticClass: "link",
    attrs: {
      "size": "normal",
      "to": _vm.getLink(_vm.current + 1)
    }
  }, [_vm._t("next", [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.nextText)
    }
  })])], 2)], 1) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dcba0a6","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/pagination/Paginator.vue
// module id = 942ec63b656988bd9057
// module chunks = 0